module.exports = __webpack_public_path__ + "static/img/icon_03.1ddf43b.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mobile/icon_03.png
// module id = 0hft
// module chunks = 6